// Module
var code = "<react-component name=\"MembershipPlanMembers\"></react-component>\n";
// Exports
module.exports = code;